import React, { useState } from "react";
import Popupz from "../../atoms/Popupz";
import Inputz from "../../atoms/Inputz";
import Buttonz from "../../atoms/Buttonz";
import { confirmPasswordReset } from "../../../auth/authApi";
import { pocketBaseErrorMessage } from "../../../auth/errors";
import { validateResetPassword } from "../../../auth/validation";
import { useDispatch } from "react-redux";
import { validationPopup } from "../../../redux/actions";

function ResetPasswordPopup({ onClose, onSuccess, resetToken }) {
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({
    password: false,
    confirmPassword: false,
  });
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    const { name, value } = e;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: false,
    }));
  };

  const handleSubmit = async () => {
    if (loading) return;
    const { errors: vErr } = validateResetPassword({
      password: formData.password,
      confirmPassword: formData.confirmPassword,
    });

    if (Object.keys(vErr).length > 0) {
      setErrors({
        password: Boolean(vErr.password),
        confirmPassword: Boolean(vErr.confirmPassword),
      });
      const msg =
        vErr.password ||
        vErr.confirmPassword ||
        "Please check your password fields.";
      dispatch(
        validationPopup({
          message: msg,
          icon: "horror",
          type: "error",
        })
      );
      return;
    }

    setLoading(true);
    dispatch(
      validationPopup({
        message: "Loading...",
        icon: "loading_ani",
      })
    );

    try {
      await confirmPasswordReset(resetToken, formData.password);
      dispatch(
        validationPopup({
          message: "Password reset successfully",
          icon: "like",
          type: "success",
        })
      );
      onSuccess();
    } catch (err) {
      dispatch(
        validationPopup({
          message: pocketBaseErrorMessage(err),
          icon: "horror",
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Popupz
      title="Reset Your Password"
      text={
        <>
          Welcome back! <br /> Enter your login details to log in to your UUD
          account.
        </>
      }
      onClose={onClose}
      popupId="login"
      iconIllus="chara0"
    >
      <div className="form-box">
        <Inputz
          type="password"
          name="password"
          iconOn="eye_on"
          iconOff="eye_off"
          placeholder="New Password"
          value={formData.password}
          onChange={handleInputChange}
          error={errors.password}
          iconL="lock"
          focusL="lock"
          label="Password"
        />
        <Inputz
          type="password"
          iconOn="eye_on"
          iconOff="eye_off"
          name="confirmPassword"
          placeholder="Confirm Password"
          value={formData.confirmPassword}
          onChange={handleInputChange}
          error={errors.confirmPassword}
          iconL="lock"
          focusL="lock"
          label="Confirm Password"
        />

        <Buttonz
          onClick={handleSubmit}
          iconR="login"
          hoverR="login"
          label="Reset Password"
        />
      </div>
    </Popupz>
  );
}

export default ResetPasswordPopup;
